interface BorderStyle {
  containerClass: string;
  animation?: string;
  priority: number;
  label: string;
}

/**
 * @deprecated Use ProfileStatusRules.getProfileBorderStyle() instead
 * Esta função é mantida para compatibilidade, mas a lógica principal está no BRE
 */
export const getProfileBorderStyle = (
  isPremium: boolean,
  isVerified: boolean,
  isOnline: boolean,
  isTopTier: boolean = false
): BorderStyle => {
  
  // Prioridade 1: Top Tier (Infinity/Sponsored Premium) = Dourado elegante com glow
  if (isTopTier) {
    return {
      containerClass: 'border-2 border-amber-400 shadow-[0_0_20px_rgba(251,191,36,0.4)]',
      animation: 'animate-gold-glow',
      priority: 1,
      label: 'infinity'
    };
  }
  
  // Prioridade 2: Plano pago (Inspire) = Dourado sutil
  if (isPremium) {
    return {
      containerClass: 'border-2 border-amber-400/50',
      priority: 2,
      label: 'inspire'
    };
  }
  
  // Prioridade 3: Online = Verde
  if (isOnline) {
    return {
      containerClass: 'border-2 border-green-500',
      priority: 3,
      label: 'online'
    };
  }
  
  // Padrão: Sem borda especial
  return {
    containerClass: 'border border-white/10',
    priority: 4,
    label: 'default'
  };
};
